import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { NgbCarousel, NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap/carousel/carousel';
import { isNullOrUndefined } from 'util';
import { ObservedRainfallDataService } from '../../side-bar/observed-weather/observed-rainfall/observed-rainfall-data.service';
import { ConstantsModule } from '../../shared/constants/constants.module';
import { UtilsSharedModule } from '../../shared/utils/utils/utils.module';
import { AppConstants } from './../application.constant';
import { Chartconstant } from 'src/app/utils/chart.constant';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { LandingPageService } from '../landing-page.service';
import { ThunderStormDataService } from '../../side-bar/thunderstorm/thunder-storm/thunder-storm-data.service';
import * as Highcharts from 'highcharts';
import { HeatwaveDataService } from '../../side-bar/heat-watch/heatwave/heatwave-data.service';
import { forkJoin } from 'rxjs';
import { NowcastDataService } from '../../side-bar/nowcast-dashboard-v2/nowcast/nowcast-data.service';
import { WindSpeedForecastDataService } from '../../side-bar/weather-forecast/wind-speed-forecast/wind-speed-forecast-data.service';
import { SeamlessRainfallDataService } from '../../side-bar/weather-forecast/seamless-rainfall/seamless-rainfall-data.service';
import { RainfallForecastDataService } from '../../side-bar/weather-forecast/rainfall-forecast/rainfall-forecast-data.service';
import { ColdwaveDataService } from '../../side-bar/cold-watch/coldwave-data.service';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})

export class LandingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("heatwaveContainer", { read: ElementRef, static: false }) public heatwaveContainer: ElementRef;
  @ViewChild("coldwaveContainer", { read: ElementRef,static:false }) public coldwaveChartContainer: ElementRef;
  // @ViewChild("thunderstormContainer", { read: ElementRef, static: false }) public thunderstormContainer: ElementRef;
  @ViewChild("nowcastContainer", { read: ElementRef, static: false }) public nowcastContainer: ElementRef;
  @ViewChild("windSpeedContainer", { read: ElementRef, static: false }) public windSpeedContainer: ElementRef;
  @ViewChild("observedRainfallContainer", { read: ElementRef, static: false }) public observedRainfallContainer: ElementRef;
  @ViewChild("rfForecastContainer", { read: ElementRef, static: false }) public rfForecastContainer: ElementRef;

  xAxisLableStuff: any;
  heatWaveChart: any;
  heatWaveChartConfig: any;
  forecastLength: string;
  rainchartData: {};
  maxWinSpd = { category: '', date: '' };
  dangerMand = 0;
  cautionMand = 0;
  flowForecasteData: any;
  flowForecastConfig = {};
  floodForecastRiverDataHardData: any;
  floodForecastPointDataHardData: any;
  rainfallChartData: any = {};
  actualRain: any;
  deviationRain: any;
  maxRainfall: any;
  chartYear : any;

  floodForecastRiverData: any;
  floodForecastPointData: any;

  resultData = {};
  requiredBasins = ['GODAVARI-BASIN', 'Krishna-Basin', 'PENNAR-BASIN', 'VAMSADARA-BASIN', 'NAGAVALI-BASIN'];
  basinCategories = ['0-250', '250-2.5K', '2.5K-5K', '5K-10K', '10K-25K', '25K-50K', '50K-100K', '100K-500K', '500K-1M', '>1M'];

  @ViewChild('carousel', { static: true }) carousel: NgbCarousel;

  showNavigationArrows = false;
  legendHide = false;
  miniMapMapping: object;
  rainFallChartData: any;
  rainFallChartConst: any;
  heatWaveChartData: any;
  heatWaveChartConst: any;
  windSpeedChartConst = {};
  windSpeedChartData = {};
  tableData: any;
  formattedChartData: any;
  blocksArray: any;
  DISTRICT_URL = 'heatWatches/getHeatWatchesCount';
  MANDAL_URL = 'heatWatches/getHeatWatchesData';
  TestData = [];
  maxDanger = { val: 0, date: '' };
  maxCaution = { val: 0, date: '' };
  ForecastRainfallmm: any;
  maxForecastRainfallData: any = {}
  maxWindSpeedCats = [];
  maxWindSpeedData: any = {}

  // Spinners
  winSpeedSpinner = true;
  rainFallSpinner = true;
  heatWaveSpinner = true;
  actualRainfallSpinner = true;
  flowForecastSpinner = true;
  startCarousel = false;
  startCarouselService: any;
  maxWinSpdDate: string;
  acRainfallArrow: boolean;
  maxFlow: string;
  mapCurrentSlide = 'actualRainfall';
  lang: string;
  currentYear:any;
  highcharts = Highcharts;
  chartSpinner: boolean = true;
  chartDataForHeatwave: any = {};
  chartDataForColdwave: any = {};
  chartDataForRfForecast: any = {};
  chartDataForNowcast: any = {};
  chartDataForWindSpeed: any = {};
  chartDataFrObservedRf: any = {};
  constructor(
    private landingServices: LandingPageService,
    private route: ActivatedRoute,
    private router: Router,
    private utils : UtilsService,
    public rainfallDataService: ObservedRainfallDataService,
    public constants: ConstantsModule,
    public utilsShared: UtilsSharedModule,
    public chartConstant: Chartconstant,
    private tsDataSrv: ThunderStormDataService,
    private dataSrv: HeatwaveDataService,
    private nowcastDataSrv: NowcastDataService,
    private windSpeedForecastDataSrv: WindSpeedForecastDataService,
    private seamlessRinfallDataSrv: SeamlessRainfallDataService,
    private rainfallForecastDataSrv: RainfallForecastDataService,
    private coldwaveDataService: ColdwaveDataService
    // public translate: TranslateService
  ) {
    this.miniMapMapping = AppConstants.WIDGETS_MAPS;
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear()
    this.lang = localStorage.getItem("lang");
    // this.translate.use(this.lang.match(/en|te|hi/) ? this.lang : 'en');

    // this.getThunderstormChartData();
    this.getHeatwaveChartData();
    this.getWindSpeedChartData();
    this.getNowcastChartData();
    this.getObservedRainfallChartData();
    this.getRainfallForecastChartData();
    this.getColdwaveChartData() 
    this.heatWaveChartConst = this.chartConstant['chartObjectHeatwave'];
    this.heatWaveChartConst.legend.enabled = this.legendHide;
    // this.chartConstant['chartObjectRainfallUnified'] = this.getForeCastRainfallChartData(this.chartConstant['chartObjectRainfallUnified']);
    this.rainFallChartConst = this.chartConstant['chartObjectRainfallUnified'];
    this.windSpeedChartConst = this.chartConstant['chartObjectWindspeedUnified'];
    // this.getAndComputeFlowForecastData();
    // this.getMaxForecastRainfallmm();
    // this.getMaxForecastWindSpeed();
    // this.getYearForChartRainfall();
  }

  ngAfterViewInit() {
    this.startCarouselService = this.landingServices.startCarousel.subscribe(value => {
      if (value === false) {
        this.startCarousel = value;
        this.carousel.pause();
      } else if (value === true) {
        this.startCarousel = value;
        setTimeout(() => {
          this.carousel.cycle();
        }, 100);
      }
    });
  }

  ngOnDestroy() {
    if (!isNullOrUndefined(this.startCarouselService)) {
      this.startCarouselService.unsubscribe();
    }
  }

  // Getting maximum rainfall from the Data
  getMaxForecastRainfallmm() {
    const rainfallParams={"primarySource":"ECMWF_DEPT","secondarySource":"null","view":"Admin","sUUID":"2b9beab2-1495-4f05-b4da-29761ebeb2ee","component":"RAINFALL","locationType":"BLOCK","forecastLength":"10","pUUID":"2b9beab2-1495-4f05-b4da-29761ebeb2ee","pType":"STATE","cType":"BLOCK"};
    const days = [];
    this.landingServices.getTableData(rainfallParams).subscribe(data => {
      Object.keys(data[0]).forEach(ele => {
        if (ele == 'table_data') {
          data[0][ele].forEach(element => {
            if (!isNullOrUndefined(days) && days.includes(+element['timeStamp']) == false) {
              days.push(+element['timeStamp'])
            } 
          });
        }
      })
      days.sort();
      const maxRainfallData = []
      data.forEach(mandal => {
        mandal['table_data'].forEach(time => {
          if (time['timeStamp'] == days[0]) {
            let obj = {
              timeStamp: time['timeStamp'],
              mandal: mandal['name'],
              rf: time['data']['rf']
            }
            maxRainfallData.push(obj);
          }
        });
      });
      // console.log("object!!!!!!!!", maxRainfallData)
      maxRainfallData.sort((a, b) => (a['rf'] < b['rf']) ? 1 : -1)
      this.maxForecastRainfallData = {
        mandalName: maxRainfallData[0]['mandal'][0].toUpperCase() + maxRainfallData[0]['mandal'].slice(1).toLowerCase(),
        rf: maxRainfallData[0]['rf'],
        timeStamp: this.landingServices.convertTimestampToBlockValue(maxRainfallData[0]['timeStamp'], '10'),
        source : 'IMD (GFS)'
      }
      // console.log("here!!!!!", this.maxForecastRainfallData)
      // data.forEach(mandal => {
      //   if (this.maxForecastRainfallData['rf'] < (mandal['table_data'].reduce((prev, current) => (prev['data']['rf'] > current['data']['rf']) ? prev : current))['data']['rf']) {
      //     this.maxForecastRainfallData = {
      //       mandalName: this.firstLetterCaptial(mandal['name']),
      //       rf: ((mandal['table_data'].reduce((prev, current) => (prev['data']['rf'] > current['data']['rf']) ? prev : current))['data']['rf']).toFixed(2),
      //       timeStamp: this.landingServices.convertTimestampToBlockValue((mandal['table_data'].reduce((prev, current) => (prev['data']['rf'] > current['data']['rf']) ? prev : current))['timeStamp'], '10')
      //     };
      //   }
      // });
    });

  }
  // To captalize all the first letter in Name
  firstLetterCaptial(arrayOfStr) {
    const tempArray = [];
    arrayOfStr.split(' ').forEach(subStr => {
      tempArray.push(String(subStr.charAt(0).toUpperCase()) + String(subStr).slice(1).toLocaleLowerCase());
    });
    arrayOfStr = tempArray;
    return arrayOfStr.join(' ');
  }

  //Get Max wind Speed
  getMaxForecastWindSpeed(){
    const windSpeedParams={"primarySource":"IMD_SHORT_RANGE","secondarySource":"IMD_LONG_RANGE","sUUID":"2b9beab2-1495-4f05-b4da-29761ebeb2ee","component":"WIND","pUUID":"2b9beab2-1495-4f05-b4da-29761ebeb2ee","pType":"STATE","forecastLength":"10","view":"Admin","cType":"BLOCK"}
    const days = [];
    this.landingServices.getTableData(windSpeedParams).subscribe(data => {
      Object.keys(data[0]).forEach(ele => {
        if (ele == 'table_data') {
          data[0][ele].forEach(element => {
            if (!isNullOrUndefined(days) && days.includes(+element['timeStamp']) == false) {
              days.push(+element['timeStamp'])
            } 
          });
        }
      })
      days.sort();
      const maxWindspeedData = []
      data.forEach(mandal => {
        mandal['table_data'].forEach(time => {
          if (time['timeStamp'] == days[0]) {
            let obj = {
              timeStamp: time['timeStamp'],
              mandal: mandal['name'],
              wg: time['data']['wg'].toFixed(2)
            }
            maxWindspeedData.push(obj);
          }
        });
      });
      maxWindspeedData.sort((a, b) => (a['rf'] < b['rf']) ? 1 : -1)
      this.maxWindSpeedData = {
        districtName: maxWindspeedData[0]['mandal'][0].toUpperCase() + maxWindspeedData[0]['mandal'].slice(1).toLowerCase(),
        maxSpeed: maxWindspeedData[0]['wg'],
        date: this.landingServices.convertTimestampToBlockValue(maxWindspeedData[0]['timeStamp'], '10'),
        source : 'IMD (GFS)'
      }
      // console.log("here!!!!!", this.maxWindSpeedData)
      // console.log('getMaxForecastWindSpeed() right Here',data)
      // data.forEach(element => {
      //   // console.log("EEE",element.name," = ",element);
      //   element.table_data.forEach(inTableData  => {
      //     if(inTableData.data.wg > this.maxWindSpeedData.maxSpeed){
      //       this.maxWindSpeedData.maxSpeed = inTableData.data.wg.toFixed(2);
      //       this.maxWindSpeedData.districtName = this.firstLetterCaptial(element.name);
      //       this.maxWindSpeedData.Date = this.landingServices.convertTimestampToBlockValue(inTableData.timeStamp, '10');
      //     }
      //   });
      // });
      // console.log("maxWind :",this.maxWindSpeedData);
      
    })
  }

  getAndComputeFlowForecastData() {
    const mxPointData = 0;
    const mxBasinName = '';
    let upStreamName;
    let downStreamName;
    let basinName;
    let basinCount = 0;
    let category: any;
    let tsKey: any;
    this.flowForecastConfig['colors'] = {
      '0-250': '#b6d1ff',
      '250-2.5K': '#7dacfb',
      '2.5K-5K': '#4e8ffd',
      '5K-10K': '#1560e0',
      '10K-25K': '#003288',
      '25K-50K': '#ffa198',
      '50K-100K': '#fb7276',
      '100K-500K': '#fa050c',
      '500K-1M': '#bb0005',
      '>1M': '#7e0000',
    };

    this.flowForecastConfig['chartType'] = 'column';
    this.flowForecastConfig['plotOptions'] = {
      series: {
        pointWidth: 16
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };
    this.flowForecastConfig['legend'] = {
      enabled: this.legendHide,
      itemWidth: 90,
      itemStyle: {
        color: '#FFFFFF'
      }
    };
    this.flowForecastConfig['chartTitle'] = '';
    this.flowForecastConfig['tooltips'] = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };
    this.flowForecastConfig['yAxisTitle'] = 'Flow';
    this.flowForecastConfig['yAxis'] = {
      min: 0,
    };
    this.flowForecastConfig['xAxisLabel'] = {
      'GODAVARI-BASIN': 'Godavari',
      'Krishna-Basin': 'Krishna',
      'PENNAR-BASIN': 'Pennar',
      'VAMSADARA-BASIN': 'Vamsadhara',
      'NAGAVALI-BASIN': 'Nagavali'
    };
    this.flowForecastConfig['datakeys'] = ['0-250', '250-2.5K', '2.5K-5K', '5K-10K', '10K-25K', '25K-50K', '50K-100K', '100K-500K', '500K-1M', '>1M'];
    this.landingServices.getfloodForecastRiverData().subscribe(riverData => {
      this.floodForecastRiverDataHardData = riverData['features'];
      this.landingServices.getfloodForecastPointData().subscribe(pointData => {
        let pData = Number.MIN_VALUE;
        this.floodForecastPointDataHardData = pointData['computedData'];
        for (let i = 0; i < this.floodForecastRiverDataHardData.length; i++) {
          upStreamName = this.floodForecastRiverDataHardData[i].properties.upstream_p;
          if (isNullOrUndefined(tsKey) && !isNullOrUndefined(this.floodForecastPointDataHardData[upStreamName])) {
            tsKey = Object.keys(this.floodForecastPointDataHardData[upStreamName])[0];
          }
          if (!isNullOrUndefined(upStreamName) && !isNullOrUndefined(this.floodForecastPointDataHardData[upStreamName])) {
            pData = this.floodForecastPointDataHardData[upStreamName][tsKey].dsof;
          }
          downStreamName = this.floodForecastRiverDataHardData[i].properties.downstream;
          if (!isNullOrUndefined(downStreamName) && !isNullOrUndefined(this.floodForecastPointDataHardData[downStreamName])) {
            pData = this.floodForecastPointDataHardData[downStreamName][tsKey].dsof;
          }

          basinName = this.floodForecastRiverDataHardData[i].properties.basin;

          if (isNullOrUndefined(this.resultData[basinName])) {
            basinCount += 1;
            this.resultData[basinName] = {};
          }

          category = this.getCategory(pData);
          if (isNullOrUndefined(this.resultData[basinName][category])) {
            this.resultData[basinName][category] = 0.0;
          }

          this.resultData[basinName][category] += this.floodForecastRiverDataHardData[i].properties.shape_leng;
        }
        this.flowForecasteData = this.clearZeroCategories(this.newFormatter());
        this.flowForecastSpinner = false;
        this.maxFlow = getMaxFlow(this.flowForecasteData);
      });
    });

    function getMaxFlow(data) {
      // console.log(data);
      let maxVal = 0;
      let maxBasinVal = 0;
      let highRecord;
      let basinName = '';
      let currentHigh = Object.keys(data);
      let order = {
        '0-250': 1,
        '250-2.5K': 2,
        '2.5K-5K': 3,
        '5K-10K': 4,
        '10K-25K': 5,
        '25K-50K': 6,
        '50K-100K': 7,
        '100K-500K': 8,
        '500K-1M': 9,
        '>1M': 10,
      };
      currentHigh.forEach(cat => {
        if (maxVal < order[cat]) {
          highRecord = cat;
          // console.log('currentHigh changing to', cat, order[cat]);
          maxVal = order[cat];
        }
      });
      Object.keys(data[highRecord]).forEach(cat => {
        if (maxBasinVal < data[highRecord][cat]) {
          maxBasinVal = data[highRecord][cat];
          basinName = cat.replace('-', ' ');
        }
      });
      // console.log('currentHighRecord',highRecord);
      // console.log('currentHighRecord MaxBasin',basinName)
      // console.log("Look Here",firstLetterCaptial(basinName))
      return highRecord + ' (' + firstLetterCaptial(basinName) + ')';
    }
    function   firstLetterCaptial(arrayOfStr) {
      const tempArray = [];
      arrayOfStr.split(' ').forEach(subStr => {
        tempArray.push(String(subStr.charAt(0).toUpperCase()) + String(subStr).slice(1).toLocaleLowerCase());
      });
      arrayOfStr = tempArray;
      return arrayOfStr.join(' ');
    }
  }

  newFormatter() {
    const requiredStuff = this.requiredBasins;
    const reFormattedData = {};
    let currentBasinValues = [];
    let stringArray = [];
    this.basinCategories.forEach(cat => {
      reFormattedData[cat] = {};
      this.requiredBasins.forEach(basinName => {
        reFormattedData[cat][basinName] = 0;
      });
    });

    Object.keys(this.resultData).forEach(basinName => {
      Object.keys(this.resultData[basinName]).forEach(cata => {
        if (requiredStuff.includes(basinName)) {
          if (cata in this.resultData[basinName]) {
            reFormattedData[cata][basinName] = this.resultData[basinName][cata];
          } else {
            reFormattedData[cata][basinName] = 0;
          }
        }
      });
    });

    Object.keys(reFormattedData['0-250']).forEach(bName => {
      Object.keys(reFormattedData).forEach(cat => {
        currentBasinValues.push(reFormattedData[cat][bName]);
        // stringArray.push({[bName] :reFormattedData[cat][bName]});
      });

      Object.keys(reFormattedData).forEach(cat => {
        reFormattedData[cat][bName] = getPerCentValue(reFormattedData[cat][bName], currentBasinValues.reduce((a, b) => a + b, 0));
      });

      currentBasinValues = [];
      stringArray = [];
    });

    function getPerCentValue(pVal, totalSum) {
      return Number(((pVal * 100) / totalSum).toFixed(2));
    }
    return reFormattedData;
  }

  getCategory(value) {
    if (value >= 0.0 && value < 250.00) {
      return '0-250';
    } else if (value >= 250 && value < 2500) {
      return '250-2.5K';
    } else if (value >= 2500 && value < 5000) {
      return '2.5K-5K';
    } else if (value >= 5000 && value < 10000) {
      return '5K-10K';
    } else if (value >= 10000 && value < 25000) {
      return '10K-25K';
    } else if (value >= 25000 && value < 50000) {
      return '25K-50K';
    } else if (value >= 50000 && value < 100000) {
      return '50K-100K';
    } else if (value >= 100000 && value < 500000) {
      return '100K-500K';
    } else if (value >= 500000 && value < 1000000) {
      return '500K-1M';
    } else if (value >= 1000000) {
      return '>1M';
    }
  }

  getMaxWindSpeed() {
    const maxWindSpeedAndDate = { category: '', date: '' };
    let sumOfMand = 0;
    Object.keys(this.windSpeedChartData).forEach(cat => {
      Object.keys(this.windSpeedChartData[cat]).forEach(ts => {
        sumOfMand += this.windSpeedChartData[cat][ts];
      });
      if (sumOfMand) {
        this.maxWindSpeedCats.push(cat);
      }
      const maxCatVar = 0;
      this.maxWindSpeedCats.forEach(maxCat => {
        if (maxCatVar < maxCat.split('-')[0] + maxCat.split('-')[1])
          maxWindSpeedAndDate['category'] = maxCat;
      });
      sumOfMand = 0;
    });
    let lastTimeStamp = 10000000000000;
    Object.keys(this.windSpeedChartData[maxWindSpeedAndDate.category]).forEach(ts => {
      if (lastTimeStamp > Number(ts) && this.windSpeedChartData[maxWindSpeedAndDate.category][ts]) {
        lastTimeStamp = Number(ts);
        maxWindSpeedAndDate['date'] = this.landingServices.convertTimestampToBlockValue(ts);
      }
    });
    return maxWindSpeedAndDate;
  }

  changeMiniMap(component) {
    if (this.startCarousel) {
      this.changeStatus(component);
      this.carousel.select(component);
      setTimeout(() => {
        this.carousel.pause();
      }, 10000);
    }
  }

  onMouseOutEvent() {
    if (this.startCarousel) {
      setTimeout(() => {
        this.carousel.cycle();
      }, 100);
    }
  }

  onSlide(slideEvent: NgbSlideEvent) {
    if (this.startCarousel) {
      // if (this.landingServices.throbberRunningStatus[AppConstants.COMPONENT_THROBBER_MAP[slideEvent.current]] === false) {
        if (slideEvent && slideEvent.current) {
          this.changeStatus(slideEvent.current);
          this.mapCurrentSlide = slideEvent.current;
        // }
        window.dispatchEvent(new Event('resize'));
       } 
       //else {
      //   this.startCarousel = false;
      //   this.carousel.pause();             
      // }
    }
  }

  changeStatus(component: string) {
    if (this.startCarousel) {
      this.miniMapMapping[component].isActive = true;
      for (const key in this.miniMapMapping) {
        if (key !== component) {
          this.miniMapMapping[key].isActive = false;
        }
      }
    }
  }

  navigate(component: string) {
    this.router.navigate([AppConstants.APP_ROUTES[component]]);
  }

  showLegend() {
    this.heatWaveChartConst['legend']['enabled'] = this.legendHide;
  }

  getForeCastRainfallChartData(chartConfig) {
    const postData = {
      primarySource: 'IMD_LONG_RANGE',
      secondarySource: 'IMD_LONG_RANGE',
      view: 'Admin',
      sUUID: '2b9beab2-1495-4f05-b4da-29761ebeb2ee',
      component: 'RAINFALL',
      locationType: 'BLOCK',
      forecastLength: '10',
      pUUID: '2b9beab2-1495-4f05-b4da-29761ebeb2ee',
      pType: 'STATE',
      cType: 'DISTRICT'
    };

    this.landingServices.makePostApiCall('CHARTDATA', postData).subscribe(data => {
      this.forecastLength = this.route.snapshot.paramMap.get('time');
      this.formattedChartData = this.landingServices.setChartData(data, ProjConstants);
      // this.rainchartData = this.heatIndexDataService.formatDataForChart(data);
      this.rainchartData = {};
      const day = []
      Object.keys(data).forEach(element => {
        Object.keys(data[element]['day']).forEach(key => {
          if (!isNullOrUndefined(day) && day.includes(+key) == false) {
            day.push(+key)
          }
        })
        day.sort();
        Object.keys(data[element]['day']).forEach(key => {
          if (+key === day[0]) {
            let obj = {};
            obj[day[0]] = +((data[element]['day'][day[0]]/670)*100).toFixed(2)
            this.rainchartData[element] = obj;
          }
        })
        // this.rainchartData[element] = data[element]['day'];
        this.rainFallSpinner = false;
      });
      chartConfig['xAxisLabel'] = {};

      chartConfig['yAxisTitle'] = 'No of Mandals';

      chartConfig['datakeys'] = [
        'no rainfall',
        'very light rainfall',
        'light rainfall',
        'moderate rainfall',
        'heavy rainfall',
        'very heavy rainfall',
        'extremely heavy rainfall'
      ];

      chartConfig['legend'] = {
        enabled: this.legendHide,
        itemWidth: 144,
        itemStyle: {
          color: '#FFFFFF'
        }
      };

      Object.keys(data['no rainfall']['day']).sort().forEach(ts => {
        if (ts == day[0]) {
          chartConfig['xAxisLabel'][ts] = this.landingServices.convertTimestampToBlockValue(ts, '10');
        }
      });
      // this.formattedChartData;
      this.rainchartData = this.clearZeroCategories(this.rainchartData);
    });
    return chartConfig;
  }

  // initializeThunderstormChart(): void {
  //   if (!this.formattedChartData) {
  //     return;
  //   }
  //   let chartDataForThunderstorm = this.tsDataSrv.getChartDataForLandingPage(this.formattedChartData);
  //   this.highcharts.chart(this.thunderstormContainer.nativeElement, chartDataForThunderstorm)
  // }

  // getThunderstormChartData() {
  //   const eDate = this.utilsShared.getModelDateWithDateFormat(new Date(Date.now()), this.constants.DATEPICKER_DATE_FORMAT.DAY);
  //   const sDate = this.utilsShared.getCurrentMonsoonrYearStartDate();
  //   const refDate = new Date();
  //   refDate.setHours(8, 30, 0, 0);
  //   const refTs = refDate.getTime();
  //   const postdata = {
  //     "parentUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
  //     "primarySource": "ECMWF_KINDEX",
  //     "secondarySource": "ECMWF_KINDEX",
  //     "view": "Admin",
  //     "pType": "COUNTRY",
  //     "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
  //     "component": "ECMWF_KINDEX",
  //     "locationType": "STATE",
  //     "forecastLength": "24",
  //     "refTs": refTs
  //   }

  //   this.landingServices.getThunderstormData(postdata).subscribe(data => {
  //     this.formattedChartData = this.tsDataSrv.setChartData(data, ProjConstants);
  //     this.initializeThunderstormChart();
  //     // this.chartSpinner = false;
  //   })
  // }

  initializeChartForHeateave(): void {
    if (!this.chartDataForHeatwave || !this.chartDataForHeatwave.Normal || !this.chartDataForHeatwave.Heatwave || !this.chartDataForHeatwave.SevereHeatwave) {
      return;
    }
    const categories = Object.keys(this.chartDataForHeatwave.Normal || {});
    let chartData = this.dataSrv.getChartDataForHeatwave(categories, this.chartDataForHeatwave);
    this.highcharts.chart(this.heatwaveContainer.nativeElement, chartData)
  }

  async getHeatwaveChartData() {
    let heatWaveCount: any
    heatWaveCount = this.getPostDataForStateHeatWaveCount();
    let actualData = this.getPostDataForStateAndDistrictActualData();
    let stateData = new Promise((resolve, reject) => {
      forkJoin(this.dataSrv.getTableDistrictData(heatWaveCount), this.dataSrv.getTableActualData(actualData)).subscribe(async (response: any) => {
        let chartWholeData = this.dataSrv.formatChartData(response[0], "Heat Wave Band", response[1]);
        if (chartWholeData) {
          this.chartDataForHeatwave = chartWholeData[0]
          this.initializeChartForHeateave();
        }
      })
    })
    await Promise.all([stateData]).then(async (payloads) => {
      let payloadData: any = await payloads[0];
    });
  }

  initializeChartForColdwave(): void {
    if (!this.coldwaveChartContainer || !this.chartDataForColdwave) return;

    const categories = Object.keys(this.chartDataForColdwave.Normal || {});

    const params = {
      locType: 'STATE'
    };

    const chartDataForColdwave =
      this.coldwaveDataService.getChartData(
        categories,
        this.chartDataForColdwave,
        params
      );

    this.highcharts.chart(
      this.coldwaveChartContainer.nativeElement,
      chartDataForColdwave
    );
  }


  async getColdwaveChartData() {
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (14 * 24 * 60 * 60 * 1000);
    let postData = {
      component: "COLDWAVE",
      "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pType": "COUNTRY",
      "cType": "STATE",
      "countLocationType": "DISTRICT",
      "startTs": startTs,
      "endTs": endTs
    }
    this.dataSrv.getTableDistrictData(postData).subscribe(
      data => {
        console.log(data, "dataataat");

        let chartWholeData = this.coldwaveDataService.formatChartData(data, "Cold Wave Band");
        console.log(chartWholeData, "dataataat chart whole data");

        if (chartWholeData) {
          this.chartDataForColdwave = chartWholeData[0]
          console.log(this.chartDataForColdwave, "chart dta for cold wave");

          this.initializeChartForColdwave();

        }
      });
  }

  getPostDataForStateHeatWaveCount() {
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (14 * 24 * 60 * 60 * 1000);
    let postData: any = {
      component: "HEATWAVE",
      "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pType": "COUNTRY",
      "cType": "STATE",
      "countLocationType": "DISTRICT",
      "source": 'IMD_LONG_RANGE',
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForStateAndDistrictActualData() {
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let postData = {
      "component": "HEATWAVE",
      "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pType": "COUNTRY",
      "cType": "STATE",
      "countLocationType": "DISTRICT",
      "startTs": startTs,
      "endTs": endTs
    }

    return postData;
  }

  initializeChartForNowcast(): void {
    if (!this.formattedChartData) {
      return;
    }
    this.chartDataForNowcast = this.nowcastDataSrv.getChartDataForLandingPage(this.formattedChartData);
    this.highcharts.chart(this.nowcastContainer.nativeElement, this.chartDataForNowcast)
  }

  getNowcastChartData() {
    let postData = {
      "view": "ADMIN",
      "colorPallette": "nowcast_color",
      "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "parentUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pType": "COUNTRY",
      "component": "NOWCAST",
      "locationType": "STATE",
      "source": "RADAR_CTT_EUMETSAT_NOWCAST"
    }
    return new Promise((resolve, reject) => {
      this.landingServices.getNowcastChartData(postData).subscribe(
        (response) => {
          this.formattedChartData = this.nowcastDataSrv.setChartData(response, ProjConstants);
          this.initializeChartForNowcast();
        })
    })
  }

  initializeChartForWindSpeed(): void {
    if (!this.formattedChartData) {
      return;
    }
    this.chartDataForWindSpeed = this.windSpeedForecastDataSrv.getChartDataForLandingPage(this.formattedChartData);
    this.highcharts.chart(this.windSpeedContainer.nativeElement, this.chartDataForWindSpeed)
  }

  getWindSpeedChartData() {
    const refDate = new Date();
    refDate.setHours(8, 30, 0, 0);
    const refTs = refDate.getTime();
    let postData = {
      "parentUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "primarySource": "IMD_LONG_RANGE",
      "secondarySource": "IMD_LONG_RANGE",
      "view": "Admin",
      "pType": "COUNTRY",
      "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "component": "WIND",
      "locationType": "STATE",
      "forecastLength": "24",
      "refTs": refTs
    }
    return new Promise((resolve, reject) => {
      this.landingServices.getWindSpeedChartData(postData).subscribe(
        (response) => {
          this.formattedChartData = this.windSpeedForecastDataSrv.setChartData(response, ProjConstants);
          this.initializeChartForWindSpeed();
        })
    })
  }

  initializeObservedRainfallChart(): void {
    if (!this.formattedChartData) return;
    this.chartDataFrObservedRf = this.seamlessRinfallDataSrv.setObservedChartDataForLandingPage(this.formattedChartData);
    this.highcharts.chart(this.observedRainfallContainer.nativeElement, this.chartDataFrObservedRf);
  }

  getObservedRainfallChartData() {
    const today = new Date();
    const startOfToday = new Date(today.setHours(5, 30, 0, 0));
    const endOfToday = new Date();
    // const today = new Date();
    // const endOfToday = new Date();
    // const startOfToday = new Date();
    // startOfToday.setDate(today.getDate() - 4);
    // startOfToday.setHours(0, 0, 0, 0);
    const postData = {
      parentUUID: "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      sourceType: "IMD_STATIONS",
      view: "Admin",
      pType: "COUNTRY",
      sUUID: "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      component: "RAINFALL",
      locationType: "STATE",
      startTs: startOfToday.getTime().toString(),
      endTs: endOfToday.getTime().toString(),
      timeStep: "HOURLY"
    };

    return new Promise((resolve, reject) => {
      this.landingServices.getObservedRainfallChartData(postData).subscribe((response) => {
        this.formattedChartData = this.seamlessRinfallDataSrv.setChartData(response, ProjConstants);
        this.initializeObservedRainfallChart();
        resolve(null);
      }, reject);
    });
  }

  initializeRfForecastChart(): void {
    if (!this.formattedChartData) {
      return;
    }
    this.chartDataForRfForecast = this.rainfallForecastDataSrv.getRfForecastChartData(this.formattedChartData);
    this.highcharts.chart(this.rfForecastContainer.nativeElement, this.chartDataForRfForecast)
  }

  getRainfallForecastChartData() {
    const refDate = new Date();
    refDate.setHours(8, 30, 0, 0);
    const refTs = refDate.getTime();
    let postData = {
      "parentUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "primarySource": "IMD_LONG_RANGE",
      "secondarySource": "IMD_LONG_RANGE",
      "view": "Admin",
      "pType": "COUNTRY",
      "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "component": "RAINFALL",
      "locationType": "STATE",
      "forecastLength": "24",
      "refTs": refTs
    }
    return new Promise((resolve, reject) => {
      this.landingServices.getRainfallForecastChartData(postData).subscribe((response) => {
        this.formattedChartData = this.seamlessRinfallDataSrv.setChartData(response, ProjConstants);
        this.initializeRfForecastChart();
        resolve(null);
      }, reject);
    });
  }

  clearZeroCategories(rawData) {
    const data = {};
    let sumOfCat = 0;
    Object.keys(rawData).forEach(cat => {
      Object.keys(rawData[cat]).forEach(bName => {
        sumOfCat += rawData[cat][bName];
      });
      if (sumOfCat) {
        data[cat] = rawData[cat];
      }
      sumOfCat = 0;
    });
    return data;
  }

  getYearForChartRainfall(){
    let date =new Date;
    let month = date.getMonth()
    if(month<5){
      this.chartYear= date.getFullYear()-1;
    }
    else{
      this.chartYear = date.getFullYear();
    }
    // console.log("YEARCHART",this.chartYear);
    
  }
}